import { useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Button from 'components/CustomButtons/Button';
// eslint-disable-next-line no-duplicate-imports -- FIXME
import ModalButton from 'components/CustomButtons/Button';
import { orderStyles } from 'views/Orders/styles';
import { Close } from '@material-ui/icons';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

const CopyPaymentLinkDialog = ({
  classes,
  history,
  isOpened,
  paymentLink,
  setIsOpened,
  paymentToPay = null,
  currency,
}) => {
  const { t } = useTranslation();

  const refMessage = useRef();

  const handleClose = () => {
    setIsOpened(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- FIXME
    history && history.push('/admin/orders');
    return toast.success(t('bagChangeModal.orderCreated'));
  };

  return (
    <Dialog maxWidth="sm" open={isOpened} onClose={handleClose}>
      <DialogTitle className={classes.modalHeader}>
        <span data-cy="new-order_modal-title">
          {t(
            'bagChangeModal.copyLinkToClipboard',
            'Skopiuj link płatności do schowka'
          )}
        </span>
      </DialogTitle>
      <DialogContent
        className={classes.modalBody}
        style={{
          minHeight: '100px',
          alignItems: 'center',
          fontSize: '1.1em',
          fontWeight: 'bold',
        }}
      >
        <ModalButton
          style={orderStyles.closeButton}
          color="transparent"
          justIcon={true}
          round={true}
          onClick={handleClose}
        >
          <Close />
        </ModalButton>
        <p ref={refMessage} data-cy="new-order_modal_payment-link">
          {paymentLink}
        </p>
        {paymentToPay && (
          <p style={{ textAlign: 'center' }}>
            <Trans
              i18nKey="bagChangeModal.paymentToPrice"
              defaults="Do zapłaty: {{ price }} {{ currencySymbol}}"
              values={{
                price: paymentToPay,
                currencySymbol: currency,
              }}
            />
          </p>
        )}
      </DialogContent>
      <DialogActions
        className={classes.modalFooter}
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <Button
          data-cy="new-order_modal_button"
          color="success"
          onClick={() => {
            navigator.clipboard.writeText(refMessage.current.innerText);
            handleClose();
          }}
        >
          {t('$*common.order.copy', 'Kopiuj')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = state => ({
  currency: state.Brands.brand.multinational.currency,
});

const enhance = compose(connect(mapStateToProps));

export default enhance(CopyPaymentLinkDialog);
